import { Box, Divider, Typography } from "@mui/joy";
import { FormProvider, useForm } from "react-hook-form";

import { ManufacturerConfiguration, Action } from "./components";
import useCreateManufacturer from "./hooks/useCreateManufacturer";
import newManufacturerResolver from "../../../../libs/form-validations/new-manufacturer";
import Breadcrumb from "./components/Breadcrumb";

import { Alert } from "../../../../shared";

const INITIAL_VALUES = {
    Name: "",
    ShortName: "",
    Headquarters: "",
    Founded: "",
    Industry: "",
    Website: "",
    Status: "Active",
};

export default function Create() {
    const { handleCreateManufacturer, createManufacturerSvc } = useCreateManufacturer();

    const methods = useForm({
        resolver: newManufacturerResolver,
        defaultValues: INITIAL_VALUES,
    });

    const onSubmit = methods.handleSubmit(handleCreateManufacturer);

    return (
        <Box flex={1}>
            <Breadcrumb />

            <Divider />

            <Box p={3} pb={0}>
                <Typography level="title-lg">New Manufacturer</Typography>
                <Typography level="body-sm">Enter the basic details for the new manufacturer.</Typography>
            </Box>
            <Box component={"div"} ml={3} width={700}>
                <FormProvider {...methods}>
                    <form onSubmit={onSubmit}>
                        <Box display={"flex"} gap={2} flexDirection={"column"}>
                            <ManufacturerConfiguration />
                            <Action api={createManufacturerSvc} />
                            <Alert
                                successMessage={createManufacturerSvc.isSuccess && "Manufacturer created successfully!"}
                                sx={{ mt: 3 }}
                                errorMessage={
                                    createManufacturerSvc.isError && "Failed to create manufacturer. Please try again."
                                }
                            />
                        </Box>
                    </form>
                </FormProvider>
            </Box>
        </Box>
    );
}
